<script lang="ts">
	interface Props {
		title?: string | null;
		clr?: string;
	}

	let { title = 'Close', clr = "hsl(var(--clr-error-5))" }: Props = $props();
</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon close-icon" style:--clr={clr}>
	{#if title}
		<title>{title}</title>
	{/if}
	<path
		d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
	/>
</svg>

<style lang="scss">
	.icon {
		width: 1rem;
        fill: var(--clr);
	}
</style>
